import React from 'react';
import ServiceTemplate from '../../components/ServicePage/ServiceTemplate';

const SASTDAST: React.FC = () => {
  const sections = [
    {
      title: 'Static and Dynamic Application Security Testing',
      content: 'Our SAST (Static Application Security Testing) and DAST (Dynamic Application Security Testing) services provide comprehensive application security assessment throughout the software development lifecycle. We identify vulnerabilities in both source code and running applications to ensure robust application security.',
      benefits: [
        'Static code analysis and vulnerability detection',
        'Dynamic runtime security testing',
        'OWASP Top 10 compliance validation',
        'Secure development lifecycle integration',
        'Automated and manual testing approaches'
      ]
    }
  ];

  return (
    <ServiceTemplate
      title="SAST / DAST"
      subtitle="Comprehensive static and dynamic application security testing to identify vulnerabilities throughout the software development lifecycle."
      sections={sections}
    />
  );
};

export default SASTDAST;

